export default {
    integrations_delete_cerebrumx_title: "Borrar Integración",
    integrations_delete_cerebrumx_description: "¿Está seguro de que quiere eliminar la integración?",
    integrations_delete_cerebrumx_success_message: "La integración ha sido eliminada",
    integrations_delete_cerebrumx_error_message: "No ha sido posible eliminar la integración debido a un error",
    integrations_delete_cerebrumx_in_use: "El paquete está vinculado a algunos usuarios, cambie el paquete de los usuarios y vuelva a intentarlo",
}